module.exports = __webpack_public_path__ + "static/media/sad-cry.41dcbb1e.svg";